import React from 'react';
import { contains } from 'underscore'

import AreaControlledItem from './AreaControlledItem';
import MultiSortableTableHeader from "../../components/MultiSortableTableHeader";

export const ItemList = (props) => {

    return (
        <table className="table table-striped">
            <thead>
            <tr>
                <th style={{verticalAlign: 'middle'}}>
                    <input name="selectItem" type="checkbox" checked={Object.keys(props.selectedItems).length > 0}
                           onChange={props.toggleAllItems}/>
                </th>
                <MultiSortableTableHeader
                        sortProperties={[{sortProperty: "currentStockQuantity", sortPropertyName: "Flächenbest."}]}
                        propertyToSortBy={props.propertyToSortBy}
                        sortDirection={props.sortDirection}
                        updateSortProperty={props.updateSortProperty}/>
                <th style={{padding: '0'}}></th>
                <th>Mindestbest.</th>
                <MultiSortableTableHeader
                        sortProperties={[{sortProperty: "replenishmentStockQuantity", sortPropertyName: "NV-Best."}]}
                        propertyToSortBy={props.propertyToSortBy}
                        sortDirection={props.sortDirection}
                        updateSortProperty={props.updateSortProperty}/>
                <th style={{padding: '0'}}></th>
                <th title={"Für Nachversorgung freigegeben"}>RF</th>
                <MultiSortableTableHeader
                        sortProperties={[{sortProperty: "retailerGln", sortPropertyName: "Händler-GLN"},
                                         {sortProperty: "storeGln", sortPropertyName: "Filial-GLN"}]}
                        propertyToSortBy={props.propertyToSortBy}
                        sortDirection={props.sortDirection}
                        updateSortProperty={props.updateSortProperty}/>
                <MultiSortableTableHeader
                        sortProperties={[{sortProperty: "retailerName", sortPropertyName: "Händler"}]}
                        propertyToSortBy={props.propertyToSortBy}
                        sortDirection={props.sortDirection}
                        updateSortProperty={props.updateSortProperty}/>
                <MultiSortableTableHeader
                        sortProperties={[{sortProperty: "storeZipCode", sortPropertyName: "PLZ"},
                            {sortProperty: "storeCity", sortPropertyName: "Ort"}]}
                        propertyToSortBy={props.propertyToSortBy}
                        sortDirection={props.sortDirection}
                        updateSortProperty={props.updateSortProperty}/>
                <MultiSortableTableHeader
                        sortProperties={[{sortProperty: "moduleName", sortPropertyName: "Modul"}]}
                        propertyToSortBy={props.propertyToSortBy}
                        sortDirection={props.sortDirection}
                        updateSortProperty={props.updateSortProperty}/>
                <MultiSortableTableHeader
                        sortProperties={[{sortProperty: "articleErpIdno", sortPropertyName: "ERP-Idno."},
                            {sortProperty: "articleGtin", sortPropertyName: "GTIN"},
                            {sortProperty: "articleName", sortPropertyName: "Details"}]}
                        propertyToSortBy={props.propertyToSortBy}
                        sortDirection={props.sortDirection}
                        updateSortProperty={props.updateSortProperty}/>
                <MultiSortableTableHeader
                        sortProperties={[{sortProperty: "articleBrand", sortPropertyName: "Hersteller"},
                                        {sortProperty: "articleVendorArticleNumber", sortPropertyName: "Hersteller Artikel-Nr."}]}
                        propertyToSortBy={props.propertyToSortBy}
                        sortDirection={props.sortDirection}
                        updateSortProperty={props.updateSortProperty}/>
                <th>Aktionen</th>
            </tr>
            </thead>
            <tbody>
            {props.items.map((item) => {
                return <AreaControlledItem {...item}
                                           isSelected={contains(props.selectedItems, item.id)}
                                           selectItem={props.selectItem}
                                           toggleAreaControl={props.toggleAreaControl}
                                           forceReplenishment={props.forceReplenishment}
                                           updateMinimumStockQuantity={props.updateMinimumStockQuantity}
                                           key={item.id}/>;
            })}
            </tbody>
        </table>
    )
};

export default ItemList;



// WEBPACK FOOTER //
// ./src/admin/areacontrol/overview/ItemList.js